import { PreloadedQuery } from "react-relay";

import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context.tsx";
// @ts-expect-error missing type declaration
import { pricingPageRelayQuery } from "@/contentful/graphql/pricing-page";
import {
    SoftwareRovoPricingPageTemplate,
    SoftwareRovoPricingPageTemplateProps
} from "@/templates/software/rovo/pricing/software-rovo-pricing-page/src/software-rovo-pricing-page.template";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content-gql.ts";

export type SoftwareRovoPricingPageProps =
    SoftwareRovoPricingPageTemplateProps & {
        pricingContent?: PricingContent;
        queryRef?: PreloadedQuery<pricingPageRelayQuery>;
    };

export const SoftwareRovoPricingPage = (
    props: SoftwareRovoPricingPageProps
) => {
    return (
        <div data-testid="rovo-pricing-page">
            <PricingContentContextProviderRelay
                productId="rovo"
                pricingContent={props.pricingContent}
                queryRef={props.queryRef}
            >
                <SoftwareRovoPricingPageTemplate {...props} />
            </PricingContentContextProviderRelay>
        </div>
    );
};
